import { PrimaryColor, GreenSidely, RedSidely } from '../../../styles/global/css/Utils';

interface EventParams {
	title: string
	event_type: number
	event_status: number
	start_date: string
	end_date: string
	client_company_id?: number
	contact_id?: number
	opportunity_id?: number
	in_charge?: number
	description?: string
	event_tag?: number
	form?: number
	scheduled: boolean
	// the creator's offset from UTC at the event's start, minutes east: the
	// server checks the company's opening hours in the creator's local time
	utc_offset_minutes?: number
}

interface Event {
	id: number
	title: string
	event_type_id: number
	event_status_id: number
	start_date: string
	end_date: string
	client_company_id?: number
	contact_id?: number
	in_charge?: number
	description?: string
}

export interface LegacyEvent {
	clientCompanyId?: number
	contactId?: number
	eventTypeId: number
	eventStatusId: number
	incharge?: number
	title?: string
	startDate: Date
	endDate: Date
	description?: string
	allDay: boolean
}

export type RepresentationMode = 'per_users' | 'per_types'

export interface CalendarMapping {
	id: number
	color: string
	label: string,
	map?: boolean
}

export const colorTypeMapping: CalendarMapping[] = [
	{ id: 1, color: GreenSidely, label: 'Task', map: true },
	{ id: 2, color: PrimaryColor, label: 'Call', map: true },
	{ id: 3, color: '#FEA240', label: 'Meeting', map: true },
	{ id: 4, color: '#12CBC3', label: 'Visit', map: true },
	{ id: 5, color: '#30739A', label: 'SMS', map: true },
	{ id: 6, color: '#4886DB', label: 'Email', map: true },
	{ id: 7, color: '#9F9FED', label: 'Animation', map: true },
	{ id: 8, color: '#A8B5C7', label: 'Promotion', map: true },
	{ id: 9, color: '#FEC940', label: 'Delivery', map: true },
	{ id: 10, color: '#B6784B', label: 'Order', map: true },
	{ id: 11, color: '#d14402', label: 'TimeOff', map: true },
	{ id: 12, color: '#729e09', label: 'PublicHoliday', map: true },
	{ id: 13, color: '#10a34b', label: 'Session', map: true },
	{ id: 14, color: '#47b0b5', label: 'Training', map: true },
	{ id: 15, color: '#0a5bab', label: 'TradeShow', map: true },
	{ id: 16, color: '#4f4bc9', label: 'SickLeave', map: true },
	{ id: 17, color: '#5d0991', label: 'WarehouseVisit', map: true },
	{ id: 18, color: '#c433b8', label: 'VehicleMaintenance', map: true },
	{ id: 19, color: '#2e072b', label: 'SampleCollection', map: true },
	{ id: 20, color: '#e34076', label: 'StoreLayout', map: true }
];

export const colorStatusMapping: CalendarMapping[] = [
	{ id: 1, color: '#FFB946', label: 'To Do' },
	{ id: 2, color: GreenSidely, label: 'Completed' },
	{ id: 3, color: RedSidely, label: 'Cancelled' }
];

export interface EventStatus {
	id: number
	name: string
	colorCode?: string
}

export interface EventType {
	id: number
	name: string
}

export {
	EventParams,
	Event
};
